import $ from '../lib/jquery';

import { Component } from '../core/component';
import { Slider } from '../core/slider';


export class ImageSlider extends Component {
    selector = '.js-image-slider';

    slider = null;

    init() {
        this.$elements.each((index, element) => {
            // eslint-disable-next-line no-new
            new Slider(`#${$(element).attr('id')}`);
        });
    }
}



// WEBPACK FOOTER //
// ./assets/js/components/ImageSlider.js